{
  "it": {
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AFI": "Afar e Issa",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Isole Åland",
      "ALB": "Albania",
      "AND": "Andorra",
      "ANT": "Antille Olandesi",
      "ARE": "Emirati Arabi Uniti",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ASM": "Samoa Americane",
      "ATA": "Antartide",
      "ATB": "Territorio Antartico Britannico",
      "ATF": "Territori Australi e Antartici Francesi",
      "ATG": "Antigua e Barbuda",
      "ATN": "Terra della Regina Maud",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaigian",
      "BDI": "Burundi",
      "BEL": "Belgio",
      "BEN": "Benin",
      "BES": "Bonaire, Sint Eustatius e Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgaria",
      "BHR": "Bahrein",
      "BHS": "Bahamas",
      "BIH": "Bosnia ed Erzegovina",
      "BLM": "Saint-Barthélemy",
      "BLR": "Bielorussia",
      "BLZ": "Belize",
      "BMU": "Bermuda",
      "BOL": "Bolivia",
      "BRA": "Brasile",
      "BRB": "Barbados",
      "BRN": "Brunei",
      "BTN": "Bhutan",
      "BUR": "Birmania",
      "BVT": "Isola Bouvet",
      "BWA": "Botswana",
      "BYS": "Bielorussia",
      "CAF": "Repubblica Centrafricana",
      "CAN": "Canada",
      "CCK": "Isole Cocos (Keeling)",
      "CHE": "Svizzera",
      "CHL": "Cile",
      "CHN": "Cina",
      "CIV": "Costa d'Avorio",
      "CMR": "Camerun",
      "COD": "Congo",
      "COG": "Congo",
      "COK": "Isole Cook",
      "COL": "Colombia",
      "COM": "Comore",
      "CPV": "Capo Verde",
      "CRI": "Costa Rica",
      "CSK": "Cecoslovacchia",
      "CTE": "Isole Canton ed Enderbury",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "Isola di Natale",
      "CYM": "Isole Cayman",
      "CYP": "Cipro",
      "CZE": "Repubblica Ceca",
      "DDR": "Germania dell'Est",
      "DEU": "Germania",
      "DHY": "Dahomey",
      "DJI": "Gibuti",
      "DMA": "Dominica",
      "DNK": "Danimarca",
      "DOM": "Repubblica Dominicana",
      "DZA": "Algeria",
      "ECU": "Ecuador",
      "EGY": "Egitto",
      "ERI": "Eritrea",
      "ESH": "Sahara Occidentale",
      "ESP": "Spagna",
      "EST": "Estonia",
      "ETH": "Etiopia",
      "FIN": "Finlandia",
      "FJI": "Figi",
      "FLK": "Isole Falkland (Malvine)",
      "FRA": "Francia",
      "FRO": "Isole Fær Øer",
      "FSM": "Micronesia",
      "FXX": "Francia Metropolitana",
      "GAB": "Gabon",
      "GBR": "Regno Unito",
      "GEL": "Isole Gilbert",
      "GEO": "Georgia",
      "GGY": "Guernsey",
      "GHA": "Ghana",
      "GIB": "Gibilterra",
      "GIN": "Guinea",
      "GLP": "Guadalupa",
      "GMB": "Gambia",
      "GNB": "Guinea-Bissau",
      "GNQ": "Guinea Equatoriale",
      "GRC": "Grecia",
      "GRD": "Grenada",
      "GRL": "Groenlandia",
      "GTM": "Guatemala",
      "GUF": "Guyana Francese",
      "GUM": "Guam",
      "GUY": "Guyana",
      "HKG": "Hong Kong",
      "HMD": "Isole Heard e McDonald",
      "HND": "Honduras",
      "HRV": "Croazia",
      "HTI": "Haiti",
      "HUN": "Ungheria",
      "HVO": "Alto Volta",
      "IDN": "Indonesia",
      "IMN": "Isola di Man",
      "IND": "India",
      "IOT": "Territorio Britannico dell'Oceano Indiano",
      "IRL": "Irlanda",
      "IRN": "Iran",
      "IRQ": "Iraq",
      "ISL": "Islanda",
      "ISR": "Israele",
      "ITA": "Italia",
      "JAM": "Giamaica",
      "JEY": "Jersey",
      "JOR": "Giordania",
      "JPN": "Giappone",
      "JTN": "Isola Johnston",
      "KAZ": "Kazakistan",
      "KEN": "Kenya",
      "KGZ": "Kirghizistan",
      "KHM": "Cambogia",
      "KIR": "Kiribati",
      "KNA": "Saint Kitts e Nevis",
      "KOR": "Corea del Sud",
      "KWT": "Kuwait",
      "LAO": "Laos",
      "LBN": "Libano",
      "LBR": "Liberia",
      "LBY": "Libia",
      "LCA": "Saint Lucia",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Lituania",
      "LUX": "Lussemburgo",
      "LVA": "Lettonia",
      "MAC": "Macao",
      "MAF": "Saint Martin (parte francese)",
      "MAR": "Marocco",
      "MCO": "Monaco",
      "MDA": "Moldavia",
      "MDG": "Madagascar",
      "MDV": "Maldive",
      "MEX": "Messico",
      "MHL": "Isole Marshall",
      "MID": "Isole Midway",
      "MKD": "Macedonia",
      "MLI": "Mali",
      "MLT": "Malta",
      "MMR": "Myanmar",
      "MNE": "Montenegro",
      "MNG": "Mongolia",
      "MNP": "Isole Marianne Settentrionali",
      "MOZ": "Mozambico",
      "MRT": "Mauritania",
      "MSR": "Montserrat",
      "MTQ": "Martinica",
      "MUS": "Mauritius",
      "MWI": "Malawi",
      "MYS": "Malesia",
      "MYT": "Mayotte",
      "NAM": "Namibia",
      "NCL": "Nuova Caledonia",
      "NER": "Niger",
      "NFK": "Isola Norfolk",
      "NGA": "Nigeria",
      "NHB": "Nuove Ebridi",
      "NIC": "Nicaragua",
      "NIU": "Niue",
      "NLD": "Paesi Bassi",
      "NOR": "Norvegia",
      "NPL": "Nepal",
      "NRU": "Nauru",
      "NTZ": "Zona Neutrale",
      "NZL": "Nuova Zelanda",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCI": "Isole del Pacifico (Territorio in amministrazione fiduciaria)",
      "PCN": "Pitcairn",
      "PCZ": "Zona del Canale di Panama",
      "PER": "Perù",
      "PHI": "Filippine",
      "PHL": "Filippine",
      "PLW": "Palau",
      "PNG": "Papua Nuova Guinea",
      "POL": "Polonia",
      "PRI": "Porto Rico",
      "PRK": "Corea del Nord",
      "PRT": "Portogallo",
      "PRY": "Paraguay",
      "PSE": "Territori palestinesi occupati",
      "PUS": "Isole minori del Pacifico degli Stati Uniti",
      "PYF": "Polinesia Francese",
      "QAT": "Qatar",
      "REU": "Riunione",
      "RHO": "Rhodesia del Sud",
      "ROU": "Romania",
      "RUS": "Russia",
      "RWA": "Ruanda",
      "SAU": "Arabia Saudita",
      "SCG": "Serbia e Montenegro",
      "SDN": "Sudan",
      "SEN": "Senegal",
      "SGP": "Singapore",
      "SGS": "Georgia del Sud e Isole Sandwich Meridionali",
      "SHN": "Sant'Elena, Ascensione e Tristan da Cunha",
      "SJM": "Svalbard e Jan Mayen",
      "SKM": "Sikkim",
      "SLB": "Isole Salomone",
      "SLE": "Sierra Leone",
      "SLV": "El Salvador",
      "SMR": "San Marino",
      "SOM": "Somalia",
      "SPM": "Saint-Pierre e Miquelon",
      "SRB": "Serbia",
      "SSD": "Sudan del Sud",
      "STP": "São Tomé e Príncipe",
      "SUN": "URSS",
      "SUR": "Suriname",
      "SVK": "Slovacchia",
      "SVN": "Slovenia",
      "SWE": "Svezia",
      "SWZ": "Swaziland",
      "SXM": "Sint Maarten (parte olandese)",
      "SYC": "Seychelles",
      "SYR": "Siria",
      "TCA": "Isole Turks e Caicos",
      "TCD": "Ciad",
      "TGO": "Togo",
      "THA": "Tailandia",
      "TJK": "Tagikistan",
      "TKL": "Tokelau",
      "TKM": "Turkmenistan",
      "TLS": "Timor Est",
      "TMP": "Timor Portoghese",
      "TON": "Tonga",
      "TTO": "Trinidad e Tobago",
      "TUN": "Tunisia",
      "TUR": "Turchia",
      "TUV": "Tuvalu",
      "TWN": "Taiwan, provincia della Cina",
      "TZA": "Tanzania",
      "UGA": "Uganda",
      "UKR": "Ucraina",
      "UMI": "Isole minori esterne degli Stati Uniti",
      "URY": "Uruguay",
      "USA": "Stati Uniti d'America",
      "UZB": "Uzbekistan",
      "VAT": "Città del Vaticano",
      "VCT": "Saint Vincent e Grenadine",
      "VDR": "Vietnam del Nord",
      "VEN": "Venezuela",
      "VGB": "Isole Vergini Britanniche",
      "VIR": "Isole Vergini Americane",
      "VNM": "Vietnam del Sud",
      "VUT": "Vanuatu",
      "WAK": "Isola Wake",
      "WLF": "Wallis e Futuna",
      "WSM": "Samoa",
      "XXX": "Sconosciuto",
      "YEM": "Yemen del Nord",
      "YMD": "Yemen del Sud",
      "YUG": "Jugoslavia",
      "ZAF": "Sudafrica",
      "ZAR": "Zaire",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe"
    }
  }
}
